/**
 * Maintenance (PMS) ▸ Postponements ekranının metinleri (ADR 0108 §4): iki uygulamada aynı liste;
 * ofiste not ve karar. Ekran ve alan adları İngilizce (menü dili); Türkçe ikinci dil.
 */

export const pmsPostponementsEn = {
  description:
    'Postponed maintenance jobs: approved on board by the Master; the office monitors, comments and may intervene.',
  allVessels: 'All vessels',
  search: 'Search job, equipment, reason...',
  status: 'Status',
  allStatuses: 'All statuses',
  title: 'Postponements',
  empty: 'No postponements yet',
  emptyHint: 'Postponements requested on board appear here with the Master’s decision.',
  noMatch: 'No postponement matches the filters.',
  kpi: {
    all: 'Total',
    pending: 'Awaiting Master approval',
    active: 'In effect',
    office: 'With office notes',
  },
  pendingNotice_one: '{{count}} postponement is waiting for the Master’s approval.',
  pendingNotice_other: '{{count}} postponements are waiting for the Master’s approval.',
  columns: {
    vessel: 'Vessel',
    job: 'Job',
    jobReason: 'Job / Reason',
    equipment: 'Equipment',
    reason: 'Reason',
    requestedBy: 'Requested By',
    approvedBy: 'Approved By (Master)',
    originalDue: 'Original Due',
    newDue: 'New Due',
    delay: 'Postponed By',
    status: 'Status',
    office: 'Office',
    requestedAt: 'Requested',
  },
  statuses: {
    pending: 'Awaiting Master',
    approved: 'Approved',
    returned: 'Returned',
    revoked: 'Revoked by office',
  },
  active: 'In effect',
  superseded: 'Ended: job done',
  officeChanged: 'Due changed by office',
  more: 'More actions for {{code}}',
  delay: {
    days_one: '{{count}} day',
    days_other: '{{count}} days',
    hours: '{{value}} h',
  },
  officeCount_one: '{{count}} note',
  officeCount_other: '{{count}} notes',
  view: 'View',
  detail: {
    title: 'Postponement · {{code}}',
    vessel: 'Vessel',
    job: 'Job',
    equipment: 'Equipment',
    workOrder: 'Work order',
    reason: 'Reason',
    classReference: 'Class reference',
    classItem: 'Class item: the class postponement follows the class society’s own process.',
    requested: 'Requested',
    approved: 'Approved by the Master',
    returned: 'Returned by the Master',
    originalDue: 'Original due (not postponed)',
    requestedDue: 'Requested new due',
    newDue: 'New due in effect',
    delay: 'Postponed by',
    byAt: '{{name}} · {{at}}',
    waiting: 'Waiting for the Master’s decision on board.',
    shipOnly:
      'The approval ends on board. The office sees every postponement and may comment, revoke it or set a new due date.',
    superseded:
      'The job was done after this postponement. The due date now follows that work record; this postponement no longer applies.',
  },
  thread: {
    title: 'Office notes and decisions',
    empty: 'No office notes yet.',
    kinds: {
      comment: 'Comment',
      revoke: 'Revoke postponement',
      change_due: 'New due date',
    },
    newDue: 'New due: {{due}}',
    seen: 'Due seen by the office: {{due}}',
    sent: 'Sent to vessel',
    applied: 'Applied on board',
    rejected: 'Not applied on board',
    rejectedReason: 'Reason: {{reason}}',
  },
  action: {
    title: 'Office action',
    kind: 'Action',
    text: 'Comment',
    reason: 'Reason',
    newDueOn: 'New due date',
    newDueHours: 'New due running hours',
    classReference: 'Class reference',
    classHint: 'Class item: an extension needs the class approval reference.',
    revokeHint:
      'The vessel applies it at the next sync: the job returns to its original due date and may become overdue.',
    changeHint:
      'The vessel applies it at the next sync. The new due must be later than the original due.',
    commentHint: 'The comment is sent to the vessel and shown with the postponement.',
    submitComment: 'Send comment',
    submitDecision: 'Send to vessel',
    pending: 'A decision is on its way to the vessel; wait for its result.',
    notApproved: 'Only comments until the Master decides.',
    sentComment: 'Comment sent to the vessel.',
    sentDecision: 'Decision sent to the vessel.',
  },
};

export const pmsPostponementsTr: typeof pmsPostponementsEn = {
  description:
    'Ertelenen bakım işleri: gemide kaptan onaylar; ofis izler, yorum yazar ve gerekirse müdahale eder.',
  allVessels: 'Bütün gemiler',
  search: 'İş, ekipman, gerekçe ara...',
  status: 'Durum',
  allStatuses: 'Bütün durumlar',
  title: 'Ertelemeler',
  empty: 'Henüz erteleme yok',
  emptyHint: 'Gemide istenen ertelemeler kaptanın kararıyla burada görünür.',
  noMatch: 'Süzgeçlere uyan erteleme yok.',
  kpi: {
    all: 'Toplam',
    pending: 'Kaptan onayı bekleyen',
    active: 'Yürürlükte',
    office: 'Ofis notu olan',
  },
  pendingNotice_one: '{{count}} erteleme kaptanın onayını bekliyor.',
  pendingNotice_other: '{{count}} erteleme kaptanın onayını bekliyor.',
  columns: {
    vessel: 'Gemi',
    job: 'İş',
    jobReason: 'İş / Gerekçe',
    equipment: 'Ekipman',
    reason: 'Gerekçe',
    requestedBy: 'Talep Eden',
    approvedBy: 'Onaylayan (Kaptan)',
    originalDue: 'Orijinal Vade',
    newDue: 'Yeni Vade',
    delay: 'Erteleme Süresi',
    status: 'Durum',
    office: 'Ofis',
    requestedAt: 'Talep',
  },
  statuses: {
    pending: 'Kaptan bekliyor',
    approved: 'Onaylandı',
    returned: 'İade edildi',
    revoked: 'Ofis geri çevirdi',
  },
  active: 'Yürürlükte',
  superseded: 'Sona erdi: iş yapıldı',
  officeChanged: 'Vadeyi ofis değiştirdi',
  more: '{{code}} için diğer eylemler',
  delay: {
    days_one: '{{count}} gün',
    days_other: '{{count}} gün',
    hours: '{{value}} sa',
  },
  officeCount_one: '{{count}} not',
  officeCount_other: '{{count}} not',
  view: 'Görüntüle',
  detail: {
    title: 'Erteleme · {{code}}',
    vessel: 'Gemi',
    job: 'İş',
    equipment: 'Ekipman',
    workOrder: 'İş emri',
    reason: 'Gerekçe',
    classReference: 'Klas referansı',
    classItem: 'Klas kalemi: klas ertelemesi klas kuruluşunun kendi sürecine tabidir.',
    requested: 'Talep',
    approved: 'Kaptan onayı',
    returned: 'Kaptan iadesi',
    originalDue: 'Orijinal vade (ertelenmemiş)',
    requestedDue: 'İstenen yeni vade',
    newDue: 'Yürürlükteki yeni vade',
    delay: 'Erteleme süresi',
    byAt: '{{name}} · {{at}}',
    waiting: 'Gemide kaptanın kararını bekliyor.',
    shipOnly:
      'Onay gemide biter. Ofis bütün ertelemeleri görür; yorum yazabilir, ertelemeyi geri çevirebilir ya da yeni vade verebilir.',
    superseded:
      'İş bu ertelemeden sonra yapıldı. Vade artık o iş kaydından hesaplanır; bu erteleme geçerli değil.',
  },
  thread: {
    title: 'Ofis notları ve kararları',
    empty: 'Henüz ofis notu yok.',
    kinds: {
      comment: 'Yorum',
      revoke: 'Ertelemeyi geri çevir',
      change_due: 'Yeni vade',
    },
    newDue: 'Yeni vade: {{due}}',
    seen: 'Ofisin gördüğü vade: {{due}}',
    sent: 'Gemiye gönderildi',
    applied: 'Gemide uygulandı',
    rejected: 'Gemide uygulanamadı',
    rejectedReason: 'Neden: {{reason}}',
  },
  action: {
    title: 'Ofis işlemi',
    kind: 'İşlem',
    text: 'Yorum',
    reason: 'Gerekçe',
    newDueOn: 'Yeni vade tarihi',
    newDueHours: 'Yeni vade çalışma saati',
    classReference: 'Klas referansı',
    classHint: 'Klas kalemi: uzatma klas onayı referansı ister.',
    revokeHint:
      'Gemi sonraki senkronda uygular: iş orijinal vadesine döner ve gecikmiş görünebilir.',
    changeHint: 'Gemi sonraki senkronda uygular. Yeni vade orijinal vadeden sonra olmalı.',
    commentHint: 'Yorum gemiye gönderilir ve ertelemeyle birlikte görünür.',
    submitComment: 'Yorumu gönder',
    submitDecision: 'Gemiye gönder',
    pending: 'Bir karar gemiye gidiyor; sonucunu bekleyin.',
    notApproved: 'Kaptan karar verene kadar yalnız yorum yazılır.',
    sentComment: 'Yorum gemiye gönderildi.',
    sentDecision: 'Karar gemiye gönderildi.',
  },
};
